import React from "react";
import {Icon, PageHeadingMeta, PageHeadingMetaItem, TextSkeleton} from "peggirkit";
import {ClockIcon, InformationCircleIcon} from "@heroicons/react/24/outline";
import {RestaurantSyncStatus} from "@/data/entities/sync";
import {formatDateTimeSeconds} from "@/utils/DateUtils";
import StatusFormatter from "@widgets/synchronization/overview/dataTable/columns/formatters/StatusFormatter";
import {FormattedMessage, useIntl} from "react-intl";


type Props = {
    restaurantSyncStatus: RestaurantSyncStatus | null,
};

const SynchronizationOverviewHeadingMeta = ({restaurantSyncStatus}: Props) => {
    const intl = useIntl();

    return (
        <PageHeadingMeta>
            <PageHeadingMetaItem
            >
                <FormattedMessage id={"currentStatus"}/>
                {
                    restaurantSyncStatus === null
                        ? <TextSkeleton className={"w-32 h-3"}/>
                        : <StatusFormatter status={restaurantSyncStatus.status}/>
                }
            </PageHeadingMetaItem>

            <PageHeadingMetaItem icon={<Icon icon={ClockIcon}/>}>
                {
                    restaurantSyncStatus === null
                        ? <TextSkeleton className={"w-32 h-3"}/>
                        : (
                            <span aria-label={intl.formatMessage({id: "currentStatusDate"})}>
                                {formatDateTimeSeconds(restaurantSyncStatus.modifiedDate)}
                            </span>
                        )
                }
            </PageHeadingMetaItem>

            <PageHeadingMetaItem icon={<Icon icon={InformationCircleIcon}/>}>
                {
                    restaurantSyncStatus === null
                        ? <TextSkeleton className={"w-44 h-3"}/>
                        : (
                            <span aria-label={intl.formatMessage({id: "currentStatusLog"})}>
                                {restaurantSyncStatus.description}
                            </span>
                        )
                }
            </PageHeadingMetaItem>
        </PageHeadingMeta>
    );
};

export default SynchronizationOverviewHeadingMeta;